module.exports = __webpack_public_path__ + "img/vancynet_login.a90e2ef0.png";